import Repository from './Repository';

export default {
    login(payload) {
        return Repository
            .post('login', {
                'email': payload.email,
                'password': payload.password
              }
            )
    },
}
